const MainPage = {
	title: 'Dê sua sugestão',
	subtitle: 'Junte-se a outros usuários para ajudar a tornar sua experiência melhor',
	login: 'Entrar',
	search: 'Busca',
	no_results: 'Nenhuma sugestão encontrada'
}

export default MainPage;